module.exports = __webpack_public_path__ + "img/slider_exp_ch.8aef0560.png";